var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsArrowLeft = function SvgIconsArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.471 2.862c.24.24.26.618.056.88l-.056.063-3.528 3.528h7.724c.368 0 .666.299.666.667 0 .342-.257.624-.589.662l-.077.005H4.943l3.528 3.528c.24.24.26.619.056.88l-.056.063c-.24.24-.618.259-.88.056l-.062-.056-4.667-4.667c-.024-.023-.045-.048-.064-.074l-.048-.074-.036-.075-.023-.07-.017-.079-.005-.04L2.667 8l.002-.05.011-.084.02-.074.03-.074.034-.065.042-.062.056-.062 4.667-4.667c.26-.26.682-.26.942 0z",
    transform: "translate(-1093 -22) translate(1069) translate(24 22)"
  })));
};
export default SvgIconsArrowLeft;